import { memo, useCallback } from 'react';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation } from 'swiper/modules';
import { Box, Stack } from '@mui/material';
import { Element } from 'react-scroll';
import { useShallow } from 'zustand/react/shallow';
import cn from 'classnames';

import PinnedVideo from '@src/components/VideoBox/PinnedVideo';
import VideoBox from '@src/components/VideoBox';
import { OButton } from '@src/shared';

import useVideosContainer from '../useVideosContainer';
import { useDrawerStore, useRoomActionsStore } from '@src/stores';

import { BiCopy } from 'react-icons/bi';

import './VideosContainerMobile.scss';

const VideosContainerMobile = () => {
  const { sortedVideos, videoStreams, pinVideo, copyUrlToClipboard, currentUser, paginatedVideos } =
    useVideosContainer();
  const { isDrawerOpen } = useDrawerStore();

  const {
    shareRoomSettings: { onClick: onShareRoomClick },
  } = useRoomActionsStore(
    useShallow((state) => ({
      shareRoomSettings: state.shareRoomSettings,
    }))
  );

  const getPinnedVideoComponent = useCallback(() => {
    if (pinVideo && !isDrawerOpen) {
      return (
        <div key="mobile" className={`video-pin-container-mobile ${videoStreams.length === 1 ? 'full-height' : ''}`}>
          <VideoBox {...pinVideo} isBigScreen key="video-pin-mobile" />
        </div>
      );
    }
    if (pinVideo && isDrawerOpen) {
      return <PinnedVideo videoStream={pinVideo} isPinned key="pinned" />;
    }
    if (currentUser) {
      return <PinnedVideo videoStream={currentUser} key="currentUser" />;
    }
    return null;
  }, [pinVideo, isDrawerOpen, videoStreams, currentUser]);

  return (
    <div className={cn('main-screen-container-mobile', { pinned: !!pinVideo })}>
      {getPinnedVideoComponent()}
      {videoStreams.length > 1 ? (
        <>
          {pinVideo ? (
            <Box id="scroll-container" className="scroll-container">
              {sortedVideos.map((video, index) => (
                <Element
                  key={`${video.peerId}-${video.type}`}
                  name={`video-${index}`}
                  className="scroll-item video-box-container"
                >
                  <VideoBox {...video} />
                </Element>
              ))}
            </Box>
          ) : (
            <Swiper
              className="swiper-container"
              modules={[Navigation, Pagination]}
              pagination={{ clickable: true }}
              spaceBetween={0}
              slidesPerView={1}
              navigation={true}
            >
              {paginatedVideos.map((videoPage, pageIndex) => (
                <SwiperSlide key={pageIndex} className="swiper-slide">
                  <div className={cn('videos-container', `count-${videoPage.length}`)}>
                    {videoPage.map((video, index) => (
                      <VideoBox key={index} {...video} />
                    ))}
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          )}
        </>
      ) : (
        !pinVideo &&
        currentUser && (
          <Stack className="empty-room" direction="column" justifyContent="center" alignItems="center">
            <p className="empty-room__message">You're the only person here.</p>
            <p className="empty-room__instruction">
              Send this to the people you'd like to meet with. Make sure to save it for later use as well.
            </p>
            <p className="empty-room__link" onClick={copyUrlToClipboard}>
              {window.location.href} <BiCopy size={24} color="#0088DD" />
            </p>
            <OButton variant="primary" text="Share invitaiton" onClick={() => onShareRoomClick(true)} />
          </Stack>
        )
      )}
    </div>
  );
};
export default memo(VideosContainerMobile);
